export default __webpack_public_path__ + "static/media/streaming.d31dd7b9.svg";